import {
  ExpiredAuthManager,
  formatAxiosConfig,
  setAxiosAccessToken,
  setAxiosInstanceMetadata,
  tokenStorage,
} from "@becon-team/becon-fe-lib/my-axios";
import { beconLog } from "@becon-team/becon-fe-lib/utils";
import { validateZodSchema } from "@becon-team/becon-fe-lib/my-zod";
import axios from "axios";
import { z } from "zod";

import type { RefreshAccessToken } from "@becon-team/becon-fe-lib/my-axios";
import type { AxiosInstance } from "axios";
import { localStorageKeyToken } from "utils/(localStorage)";
import { postBeconLog } from "modules/becon/services/becon.handler";
import { projectConfig } from "projectConfig";

export const TIMEOUT = 15000;

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_GLOBAL_API_BASE_URL,
  headers: {},
  timeout: TIMEOUT,
});

export const kakaoAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});
// 초기 access-token 설성
const initializeAccessToken = () => {
  const initialAccessToken = tokenStorage.getTokenInLocalStorage(localStorageKeyToken);

  if (initialAccessToken?.accessToken) {
    setAxiosAccessToken(axiosInstance, initialAccessToken.accessToken);
  }
};
initializeAccessToken();

// access-token 갱신 함수 (refresh-token 사용)
const refreshAccessToken: RefreshAccessToken = async (axiosInstance: AxiosInstance, refreshToken: string) => {
  const serverRes = await axiosInstance.post("/account/auth/refresh", {
    refresh_token: refreshToken,
  });

  const validatedData = validateZodSchema(
    serverRes.data,
    z.object({ access_token: z.string() }),
    formatAxiosConfig(serverRes.config),
  );
  const newAccessToken = validatedData.access_token;

  setAxiosAccessToken(axiosInstance, newAccessToken);

  tokenStorage.setTokenInLocalStorage(localStorageKeyToken, {
    refreshToken,
    accessToken: newAccessToken,
  });

  return newAccessToken;
};

// 요청 출발 시간 및 응답 도착 시간 측정
setAxiosInstanceMetadata(axiosInstance, {
  // *정책: 요청이 성공하더라도 RTT가 3초 초과일 때 기록
  delay: 3000,
  executeAfterDelayEvenOnSuccess: (delay, config) => {
    postBeconLog(
      beconLog.ROUNDTRIP_SLOW({
        kind: projectConfig.project.kind,
        status: "success",
        message: `>${delay}ms`,
        config,
        localStorageKeyToken,
      }),
    );
  },
});

// 응답 인터셉터 추가 (refresh-token 사용)
export const expiredAuthManager = new ExpiredAuthManager();
export const expiredAuthInterceptorId = axiosInstance.interceptors.response.use(
  (res) => res,
  expiredAuthManager.interceptResponseError({ axiosInstance, localStorageKeyToken, refreshAccessToken }),
);
